import React, { memo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { setFilterMenuStatus, setNiveauFilterDataArray, setNiveauFilterId } from '../actions';
import { loadCourses } from '../../App/actions';
import CollapsedList from '../../../utils/Components/CollapsedList';
import FilterCollapse from './FilterCollapse';
import FilterOverlayBlock from '../../../utils/Components/FilterOverlayBlock';
import { FilterHeaderBlock } from '../FilterOverlay/FilterHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import LocalReset from '../../../utils/Components/LocalReset';
import CurrentFilterResetBlock from '../../../components/CurrentFilterResetBlock';
import { useInjectReducer } from '../../../utils/injectReducer';
import reducer from './reducer';
import { initialState } from '../reducer';
import { makeSelectNiveauFilterMenuStatus } from './selectors';
import { toggleNiveauFilterMenu } from './actions';
import Items from './Items';
import ShowResultsButton from '../../../utils/Components/ShowResultsButton';
import FilterListWrapper from '../../../utils/Components/FilterListWrapper';
import { NIVEAU_FILTER_LABEL } from '../../../utils/site';

const key = 'niveau';

export function SearchNiveau({
  niveauFilterMenuStatus,
  onToggleNiveauFilterMenu,
  onSetNiveauFilterDataArray,
  onSetNiveauFilterId,
  onSetFilterMenuStatus,
}) {
  useInjectReducer({ key, reducer });

  const resetFilter = () => {
    onSetNiveauFilterId(initialState.niveauFilterId);
    onSetNiveauFilterDataArray(initialState.niveauFilterDataArray);
  };

  const handleResultsClick = () => {
    onToggleNiveauFilterMenu(false);
    onSetFilterMenuStatus(false);
  };

  const CurrentFilterReset = () => (
    <LocalReset onClick={() => resetFilter()}>
      <CurrentFilterResetBlock />
    </LocalReset>
  );

  /**
   * Main return function.
   */
  return (
    <CollapsedList className={niveauFilterMenuStatus ? 'open' : ''}>
      <FilterCollapse />
      <FilterOverlayBlock className={'item-list'}>
        <FilterHeaderBlock>
          <span>{NIVEAU_FILTER_LABEL.toUpperCase()}</span>
          <FontAwesomeIcon icon={faArrowLeft} onClick={() => onToggleNiveauFilterMenu(false)} />
        </FilterHeaderBlock>
        <CurrentFilterReset />
        <FilterListWrapper>
          <Items />
        </FilterListWrapper>
        <ShowResultsButton onClick={() => handleResultsClick()}>Resultate anzeigen</ShowResultsButton>
      </FilterOverlayBlock>
    </CollapsedList>
  );
}

SearchNiveau.propTypes = {
  niveauFilterMenuStatus: PropTypes.bool,
  onToggleNiveauFilterMenu: PropTypes.func,
  onSetNiveauFilterDataArray: PropTypes.func,
  onSetNiveauFilterId: PropTypes.func,
  onSetFilterMenuStatus: PropTypes.func,
};

SearchNiveau.defaultProps = {
  niveauFilterMenuStatus: false,
  onToggleNiveauFilterMenu: () => {},
  onSetNiveauFilterDataArray: () => {},
  onSetNiveauFilterId: () => {},
  onSetFilterMenuStatus: () => {},
};

const mapStateToProps = createStructuredSelector({
  niveauFilterMenuStatus: makeSelectNiveauFilterMenuStatus(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onToggleNiveauFilterMenu: (value) => dispatch(toggleNiveauFilterMenu(value)),
    onSetNiveauFilterDataArray: (value) => dispatch(setNiveauFilterDataArray(value)),
    onSetNiveauFilterId: (value) => dispatch(setNiveauFilterId(value)),
    onSetFilterMenuStatus: (value) => dispatch(setFilterMenuStatus(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(SearchNiveau);
